import React from 'react';
import { useMobileContext } from '../../contexts/MobileContext';
import ScrollFadeWrapper from '../ScrollFadeWrapper/ScrollFadeWrapper';
import LaunchPad from '../HomePage/LaunchPad/LaunchPadComponent';
import LaunchPadMobile from '../HomePage/LaunchPad/LaunchPadMobileComponent ';
import CarInsuranceLaunchPadHeroDesktop from '../HomePage/LaunchPad/LaunchPadHeroDesktopComponent';
import CarInsuranceLaunchPadHeroMobile from '../HomePage/LaunchPad/LaunchPadHeroMobileComponent';
import launchPadHeroData from '../../json/components/HomePages/CarInsurance/launchPadHeroData.json';
import funeralInsuranceLaunchPadHeroData from '../../json/components/HomePages/FuneralInsurance/launchPadHeroData.json';
import buildingInsuranceLaunchPadHeroData from '../../json/components/HomePages/BuildingInsurance/launchPadHeroData.json';
import homeContentsLaunchPadHeroData from '../../json/components/HomePages/HomeContentsInsurance/launchPadHeroData.json';
import lifeInsuranceLaunchPadHeroData from '../../json/components/HomePages/LifeInsurance/launchPadHeroData.json';
import medicalAidLaunchPadHeroData from '../../json/components/HomePages/MedicalAid/launchPadHeroData.json';
import medicalInsuranceLaunchPadHeroData from '../../json/components/HomePages/MedicalInsurance/launchPadHeroData.json';
import petInsuranceLaunchPadHeroData from '../../json/components/HomePages/PetInsurance/launchPadHeroData.json';
import businessInsuranceLaunchPadHeroData from '../../json/components/HomePages/BusinessInsurance/launchPadHeroData.json';
import servicePlansLaunchPadHeroData from '../../json/components/HomePages/ServicePlans/launchPadHeroData.json';
import dentsAndScratchesLaunchPadHeroData from '../../json/components/HomePages/DentsAndScratches/launchPadHeroData.json';
import gapCoverLaunchPadHeroData from '../../json/components/HomePages/GapCover/launchPadHeroData.json';
import motorWarrantyLaunchPadHeroData from '../../json/components/HomePages/MotorWarranty/launchPadHeroData.json';
import tyreAndRimLaunchPadHeroData from '../../json/components/HomePages/TyreAndRim/launchPadHeroData.json';
import vehicleTrackingLaunchPadHeroData from '../../json/components/HomePages/VehicleTracking/launchPadHeroData.json';
import travelInsuranceLaunchPadHeroData from '../../json/components/HomePages/TravelInsurance/launchPadHeroData.json';
import comboInsuranceLaunchPadHeroData from '../../json/components/HomePages/ComboInsurance/launchPadHeroData.json';
import personalLoansLaunchPadHeroData from '../../json/components/HomePages/PersonalLoans/launchPadHeroData.json';
import debtCounsellingLaunchPadHeroData from '../../json/components/HomePages/DebtCounselling/launchPadHeroData.json';
import debtConsolidationLaunchPadHeroData from '../../json/components/HomePages/DebtConsolidation/launchPadHeroData.json';
import commercialPropertyLaunchPadHeroData from '../../json/components/HomePages/CommercialProperty/launchPadHeroData.json';
import businessLegalCoverLaunchPadHeroData from '../../json/components/HomePages/BusinessLegalCover/launchPadHeroData.json';
import eventLiabilityCoverLaunchPadHeroData from '../../json/components/HomePages/EventLiabilityCover/launchPadHeroData.json';
import professionalLiabilityLaunchPadHeroData from '../../json/components/HomePages/ProfessionalLiability/launchPadHeroData.json';
import employeeBenefitsLaunchPadHeroData from '../../json/components/HomePages/EmployeeBenefits/launchPadHeroData.json';
import motorCycleLaunchPadHeroData from '../../json/components/HomePages/MotorCycleInsurance/launchPadHeroData.json';
import fibreLaunchPadHeroData from '../../json/components/HomePages/FibrePage/launchPadHeroData.json';

const SubPageHero = ({ pathName = '/', heroGateKey, onImageLoad = null }) => {
  const isMobile = useMobileContext();

  if (pathName === '/car-insurance-quote') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={launchPadHeroData.title}
            subtitle={launchPadHeroData.subtitle}
            ctaLabel={launchPadHeroData.ctaLabel}
            ctaRoute={launchPadHeroData.ctaRoute}
            imageSrc={launchPadHeroData.imageSrc}
            imageAlt={launchPadHeroData.imageAlt}
            features={launchPadHeroData.features}
            footnote={launchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={launchPadHeroData.title}
            subtitle={launchPadHeroData.subtitle}
            ctaLabel={launchPadHeroData.ctaLabel}
            ctaRoute={launchPadHeroData.ctaRoute}
            imageSrc={launchPadHeroData.imageSrc}
            imageAlt={launchPadHeroData.imageAlt}
            features={launchPadHeroData.features}
            footnote={launchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/medical-aid-quote') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={medicalAidLaunchPadHeroData.title}
            subtitle={medicalAidLaunchPadHeroData.subtitle}
            ctaLabel={medicalAidLaunchPadHeroData.ctaLabel}
            ctaRoute={medicalAidLaunchPadHeroData.ctaRoute}
            imageSrc={medicalAidLaunchPadHeroData.imageSrc}
            imageAlt={medicalAidLaunchPadHeroData.imageAlt}
            features={medicalAidLaunchPadHeroData.features}
            footnote={medicalAidLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={medicalAidLaunchPadHeroData.title}
            subtitle={medicalAidLaunchPadHeroData.subtitle}
            ctaLabel={medicalAidLaunchPadHeroData.ctaLabel}
            ctaRoute={medicalAidLaunchPadHeroData.ctaRoute}
            imageSrc={medicalAidLaunchPadHeroData.imageSrc}
            imageAlt={medicalAidLaunchPadHeroData.imageAlt}
            features={medicalAidLaunchPadHeroData.features}
            footnote={medicalAidLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/medical-gap-cover-quote') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={gapCoverLaunchPadHeroData.title}
            subtitle={gapCoverLaunchPadHeroData.subtitle}
            ctaLabel={gapCoverLaunchPadHeroData.ctaLabel}
            ctaRoute={gapCoverLaunchPadHeroData.ctaRoute}
            imageSrc={gapCoverLaunchPadHeroData.imageSrc}
            imageAlt={gapCoverLaunchPadHeroData.imageAlt}
            features={gapCoverLaunchPadHeroData.features}
            footnote={gapCoverLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={gapCoverLaunchPadHeroData.title}
            subtitle={gapCoverLaunchPadHeroData.subtitle}
            ctaLabel={gapCoverLaunchPadHeroData.ctaLabel}
            ctaRoute={gapCoverLaunchPadHeroData.ctaRoute}
            imageSrc={gapCoverLaunchPadHeroData.imageSrc}
            imageAlt={gapCoverLaunchPadHeroData.imageAlt}
            features={gapCoverLaunchPadHeroData.features}
            footnote={gapCoverLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/medical-insurance-quotes') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={medicalInsuranceLaunchPadHeroData.title}
            subtitle={medicalInsuranceLaunchPadHeroData.subtitle}
            ctaLabel={medicalInsuranceLaunchPadHeroData.ctaLabel}
            ctaRoute={medicalInsuranceLaunchPadHeroData.ctaRoute}
            imageSrc={medicalInsuranceLaunchPadHeroData.imageSrc}
            imageAlt={medicalInsuranceLaunchPadHeroData.imageAlt}
            features={medicalInsuranceLaunchPadHeroData.features}
            footnote={medicalInsuranceLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={medicalInsuranceLaunchPadHeroData.title}
            subtitle={medicalInsuranceLaunchPadHeroData.subtitle}
            ctaLabel={medicalInsuranceLaunchPadHeroData.ctaLabel}
            ctaRoute={medicalInsuranceLaunchPadHeroData.ctaRoute}
            imageSrc={medicalInsuranceLaunchPadHeroData.imageSrc}
            imageAlt={medicalInsuranceLaunchPadHeroData.imageAlt}
            features={medicalInsuranceLaunchPadHeroData.features}
            footnote={medicalInsuranceLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/pet-insurance-quote') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={petInsuranceLaunchPadHeroData.title}
            subtitle={petInsuranceLaunchPadHeroData.subtitle}
            ctaLabel={petInsuranceLaunchPadHeroData.ctaLabel}
            ctaRoute={petInsuranceLaunchPadHeroData.ctaRoute}
            imageSrc={petInsuranceLaunchPadHeroData.imageSrc}
            imageAlt={petInsuranceLaunchPadHeroData.imageAlt}
            features={petInsuranceLaunchPadHeroData.features}
            footnote={petInsuranceLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={petInsuranceLaunchPadHeroData.title}
            subtitle={petInsuranceLaunchPadHeroData.subtitle}
            ctaLabel={petInsuranceLaunchPadHeroData.ctaLabel}
            ctaRoute={petInsuranceLaunchPadHeroData.ctaRoute}
            imageSrc={petInsuranceLaunchPadHeroData.imageSrc}
            imageAlt={petInsuranceLaunchPadHeroData.imageAlt}
            features={petInsuranceLaunchPadHeroData.features}
            footnote={petInsuranceLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/business-insurance-quote') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={businessInsuranceLaunchPadHeroData.title}
            subtitle={businessInsuranceLaunchPadHeroData.subtitle}
            ctaLabel={businessInsuranceLaunchPadHeroData.ctaLabel}
            ctaRoute={businessInsuranceLaunchPadHeroData.ctaRoute}
            imageSrc={businessInsuranceLaunchPadHeroData.imageSrc}
            imageAlt={businessInsuranceLaunchPadHeroData.imageAlt}
            features={businessInsuranceLaunchPadHeroData.features}
            footnote={businessInsuranceLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={businessInsuranceLaunchPadHeroData.title}
            subtitle={businessInsuranceLaunchPadHeroData.subtitle}
            ctaLabel={businessInsuranceLaunchPadHeroData.ctaLabel}
            ctaRoute={businessInsuranceLaunchPadHeroData.ctaRoute}
            imageSrc={businessInsuranceLaunchPadHeroData.imageSrc}
            imageAlt={businessInsuranceLaunchPadHeroData.imageAlt}
            features={businessInsuranceLaunchPadHeroData.features}
            footnote={businessInsuranceLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/business-insurance-quote/business-legal-cover') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={businessLegalCoverLaunchPadHeroData.title}
            subtitle={businessLegalCoverLaunchPadHeroData.subtitle}
            ctaLabel={businessLegalCoverLaunchPadHeroData.ctaLabel}
            ctaRoute={businessLegalCoverLaunchPadHeroData.ctaRoute}
            imageSrc={businessLegalCoverLaunchPadHeroData.imageSrc}
            imageAlt={businessLegalCoverLaunchPadHeroData.imageAlt}
            features={businessLegalCoverLaunchPadHeroData.features}
            footnote={businessLegalCoverLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={businessLegalCoverLaunchPadHeroData.title}
            subtitle={businessLegalCoverLaunchPadHeroData.subtitle}
            ctaLabel={businessLegalCoverLaunchPadHeroData.ctaLabel}
            ctaRoute={businessLegalCoverLaunchPadHeroData.ctaRoute}
            imageSrc={businessLegalCoverLaunchPadHeroData.imageSrc}
            imageAlt={businessLegalCoverLaunchPadHeroData.imageAlt}
            features={businessLegalCoverLaunchPadHeroData.features}
            footnote={businessLegalCoverLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/business-insurance-quote/event-liability-insurance') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={eventLiabilityCoverLaunchPadHeroData.title}
            subtitle={eventLiabilityCoverLaunchPadHeroData.subtitle}
            ctaLabel={eventLiabilityCoverLaunchPadHeroData.ctaLabel}
            ctaRoute={eventLiabilityCoverLaunchPadHeroData.ctaRoute}
            imageSrc={eventLiabilityCoverLaunchPadHeroData.imageSrc}
            imageAlt={eventLiabilityCoverLaunchPadHeroData.imageAlt}
            features={eventLiabilityCoverLaunchPadHeroData.features}
            footnote={eventLiabilityCoverLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={eventLiabilityCoverLaunchPadHeroData.title}
            subtitle={eventLiabilityCoverLaunchPadHeroData.subtitle}
            ctaLabel={eventLiabilityCoverLaunchPadHeroData.ctaLabel}
            ctaRoute={eventLiabilityCoverLaunchPadHeroData.ctaRoute}
            imageSrc={eventLiabilityCoverLaunchPadHeroData.imageSrc}
            imageAlt={eventLiabilityCoverLaunchPadHeroData.imageAlt}
            features={eventLiabilityCoverLaunchPadHeroData.features}
            footnote={eventLiabilityCoverLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/compare-fibre-deals') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={fibreLaunchPadHeroData.title}
            subtitle={fibreLaunchPadHeroData.subtitle}
            ctaLabel={fibreLaunchPadHeroData.ctaLabel}
            ctaRoute={fibreLaunchPadHeroData.ctaRoute}
            imageSrc={fibreLaunchPadHeroData.imageSrc}
            imageAlt={fibreLaunchPadHeroData.imageAlt}
            features={fibreLaunchPadHeroData.features}
            footnote={fibreLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={fibreLaunchPadHeroData.title}
            subtitle={fibreLaunchPadHeroData.subtitle}
            ctaLabel={fibreLaunchPadHeroData.ctaLabel}
            ctaRoute={fibreLaunchPadHeroData.ctaRoute}
            imageSrc={fibreLaunchPadHeroData.imageSrc}
            imageAlt={fibreLaunchPadHeroData.imageAlt}
            features={fibreLaunchPadHeroData.features}
            footnote={fibreLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/motorcycle-insurance-quote') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={motorCycleLaunchPadHeroData.title}
            subtitle={motorCycleLaunchPadHeroData.subtitle}
            ctaLabel={motorCycleLaunchPadHeroData.ctaLabel}
            ctaRoute={motorCycleLaunchPadHeroData.ctaRoute}
            imageSrc={motorCycleLaunchPadHeroData.imageSrc}
            imageAlt={motorCycleLaunchPadHeroData.imageAlt}
            features={motorCycleLaunchPadHeroData.features}
            footnote={motorCycleLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={motorCycleLaunchPadHeroData.title}
            subtitle={motorCycleLaunchPadHeroData.subtitle}
            ctaLabel={motorCycleLaunchPadHeroData.ctaLabel}
            ctaRoute={motorCycleLaunchPadHeroData.ctaRoute}
            imageSrc={motorCycleLaunchPadHeroData.imageSrc}
            imageAlt={motorCycleLaunchPadHeroData.imageAlt}
            features={motorCycleLaunchPadHeroData.features}
            footnote={motorCycleLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/employee-benefits-quote') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={employeeBenefitsLaunchPadHeroData.title}
            subtitle={employeeBenefitsLaunchPadHeroData.subtitle}
            ctaLabel={employeeBenefitsLaunchPadHeroData.ctaLabel}
            ctaRoute={employeeBenefitsLaunchPadHeroData.ctaRoute}
            imageSrc={employeeBenefitsLaunchPadHeroData.imageSrc}
            imageAlt={employeeBenefitsLaunchPadHeroData.imageAlt}
            features={employeeBenefitsLaunchPadHeroData.features}
            footnote={employeeBenefitsLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={employeeBenefitsLaunchPadHeroData.title}
            subtitle={employeeBenefitsLaunchPadHeroData.subtitle}
            ctaLabel={employeeBenefitsLaunchPadHeroData.ctaLabel}
            ctaRoute={employeeBenefitsLaunchPadHeroData.ctaRoute}
            imageSrc={employeeBenefitsLaunchPadHeroData.imageSrc}
            imageAlt={employeeBenefitsLaunchPadHeroData.imageAlt}
            features={employeeBenefitsLaunchPadHeroData.features}
            footnote={employeeBenefitsLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (
    pathName ===
    '/business-insurance-quote/professional-liability-insurance-cover'
  ) {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={professionalLiabilityLaunchPadHeroData.title}
            subtitle={professionalLiabilityLaunchPadHeroData.subtitle}
            ctaLabel={professionalLiabilityLaunchPadHeroData.ctaLabel}
            ctaRoute={professionalLiabilityLaunchPadHeroData.ctaRoute}
            imageSrc={professionalLiabilityLaunchPadHeroData.imageSrc}
            imageAlt={professionalLiabilityLaunchPadHeroData.imageAlt}
            features={professionalLiabilityLaunchPadHeroData.features}
            footnote={professionalLiabilityLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={professionalLiabilityLaunchPadHeroData.title}
            subtitle={professionalLiabilityLaunchPadHeroData.subtitle}
            ctaLabel={professionalLiabilityLaunchPadHeroData.ctaLabel}
            ctaRoute={professionalLiabilityLaunchPadHeroData.ctaRoute}
            imageSrc={professionalLiabilityLaunchPadHeroData.imageSrc}
            imageAlt={professionalLiabilityLaunchPadHeroData.imageAlt}
            features={professionalLiabilityLaunchPadHeroData.features}
            footnote={professionalLiabilityLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/buildings-insurance-quote') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={buildingInsuranceLaunchPadHeroData.title}
            subtitle={buildingInsuranceLaunchPadHeroData.subtitle}
            ctaLabel={buildingInsuranceLaunchPadHeroData.ctaLabel}
            ctaRoute={buildingInsuranceLaunchPadHeroData.ctaRoute}
            imageSrc={buildingInsuranceLaunchPadHeroData.imageSrc}
            imageAlt={buildingInsuranceLaunchPadHeroData.imageAlt}
            features={buildingInsuranceLaunchPadHeroData.features}
            footnote={buildingInsuranceLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={buildingInsuranceLaunchPadHeroData.title}
            subtitle={buildingInsuranceLaunchPadHeroData.subtitle}
            ctaLabel={buildingInsuranceLaunchPadHeroData.ctaLabel}
            ctaRoute={buildingInsuranceLaunchPadHeroData.ctaRoute}
            imageSrc={buildingInsuranceLaunchPadHeroData.imageSrc}
            imageAlt={buildingInsuranceLaunchPadHeroData.imageAlt}
            features={buildingInsuranceLaunchPadHeroData.features}
            footnote={buildingInsuranceLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/service-plan-quotes') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={servicePlansLaunchPadHeroData.title}
            subtitle={servicePlansLaunchPadHeroData.subtitle}
            ctaLabel={servicePlansLaunchPadHeroData.ctaLabel}
            ctaRoute={servicePlansLaunchPadHeroData.ctaRoute}
            imageSrc={servicePlansLaunchPadHeroData.imageSrc}
            imageAlt={servicePlansLaunchPadHeroData.imageAlt}
            features={servicePlansLaunchPadHeroData.features}
            footnote={servicePlansLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={servicePlansLaunchPadHeroData.title}
            subtitle={servicePlansLaunchPadHeroData.subtitle}
            ctaLabel={servicePlansLaunchPadHeroData.ctaLabel}
            ctaRoute={servicePlansLaunchPadHeroData.ctaRoute}
            imageSrc={servicePlansLaunchPadHeroData.imageSrc}
            imageAlt={servicePlansLaunchPadHeroData.imageAlt}
            features={servicePlansLaunchPadHeroData.features}
            footnote={servicePlansLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/dents-and-scratches-quote') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={dentsAndScratchesLaunchPadHeroData.title}
            subtitle={dentsAndScratchesLaunchPadHeroData.subtitle}
            ctaLabel={dentsAndScratchesLaunchPadHeroData.ctaLabel}
            ctaRoute={dentsAndScratchesLaunchPadHeroData.ctaRoute}
            imageSrc={dentsAndScratchesLaunchPadHeroData.imageSrc}
            imageAlt={dentsAndScratchesLaunchPadHeroData.imageAlt}
            features={dentsAndScratchesLaunchPadHeroData.features}
            footnote={dentsAndScratchesLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={dentsAndScratchesLaunchPadHeroData.title}
            subtitle={dentsAndScratchesLaunchPadHeroData.subtitle}
            ctaLabel={dentsAndScratchesLaunchPadHeroData.ctaLabel}
            ctaRoute={dentsAndScratchesLaunchPadHeroData.ctaRoute}
            imageSrc={dentsAndScratchesLaunchPadHeroData.imageSrc}
            imageAlt={dentsAndScratchesLaunchPadHeroData.imageAlt}
            features={dentsAndScratchesLaunchPadHeroData.features}
            footnote={dentsAndScratchesLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/motor-warranty') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={motorWarrantyLaunchPadHeroData.title}
            subtitle={motorWarrantyLaunchPadHeroData.subtitle}
            ctaLabel={motorWarrantyLaunchPadHeroData.ctaLabel}
            ctaRoute={motorWarrantyLaunchPadHeroData.ctaRoute}
            imageSrc={motorWarrantyLaunchPadHeroData.imageSrc}
            imageAlt={motorWarrantyLaunchPadHeroData.imageAlt}
            features={motorWarrantyLaunchPadHeroData.features}
            footnote={motorWarrantyLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={motorWarrantyLaunchPadHeroData.title}
            subtitle={motorWarrantyLaunchPadHeroData.subtitle}
            ctaLabel={motorWarrantyLaunchPadHeroData.ctaLabel}
            ctaRoute={motorWarrantyLaunchPadHeroData.ctaRoute}
            imageSrc={motorWarrantyLaunchPadHeroData.imageSrc}
            imageAlt={motorWarrantyLaunchPadHeroData.imageAlt}
            features={motorWarrantyLaunchPadHeroData.features}
            footnote={motorWarrantyLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/tyre-and-rim-guard') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={tyreAndRimLaunchPadHeroData.title}
            subtitle={tyreAndRimLaunchPadHeroData.subtitle}
            ctaLabel={tyreAndRimLaunchPadHeroData.ctaLabel}
            ctaRoute={tyreAndRimLaunchPadHeroData.ctaRoute}
            imageSrc={tyreAndRimLaunchPadHeroData.imageSrc}
            imageAlt={tyreAndRimLaunchPadHeroData.imageAlt}
            features={tyreAndRimLaunchPadHeroData.features}
            footnote={tyreAndRimLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={tyreAndRimLaunchPadHeroData.title}
            subtitle={tyreAndRimLaunchPadHeroData.subtitle}
            ctaLabel={tyreAndRimLaunchPadHeroData.ctaLabel}
            ctaRoute={tyreAndRimLaunchPadHeroData.ctaRoute}
            imageSrc={tyreAndRimLaunchPadHeroData.imageSrc}
            imageAlt={tyreAndRimLaunchPadHeroData.imageAlt}
            features={tyreAndRimLaunchPadHeroData.features}
            footnote={tyreAndRimLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/vehicle-tracking-quote') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={vehicleTrackingLaunchPadHeroData.title}
            subtitle={vehicleTrackingLaunchPadHeroData.subtitle}
            ctaLabel={vehicleTrackingLaunchPadHeroData.ctaLabel}
            ctaRoute={vehicleTrackingLaunchPadHeroData.ctaRoute}
            imageSrc={vehicleTrackingLaunchPadHeroData.imageSrc}
            imageAlt={vehicleTrackingLaunchPadHeroData.imageAlt}
            features={vehicleTrackingLaunchPadHeroData.features}
            footnote={vehicleTrackingLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={vehicleTrackingLaunchPadHeroData.title}
            subtitle={vehicleTrackingLaunchPadHeroData.subtitle}
            ctaLabel={vehicleTrackingLaunchPadHeroData.ctaLabel}
            ctaRoute={vehicleTrackingLaunchPadHeroData.ctaRoute}
            imageSrc={vehicleTrackingLaunchPadHeroData.imageSrc}
            imageAlt={vehicleTrackingLaunchPadHeroData.imageAlt}
            features={vehicleTrackingLaunchPadHeroData.features}
            footnote={vehicleTrackingLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/travel-insurance') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={travelInsuranceLaunchPadHeroData.title}
            subtitle={travelInsuranceLaunchPadHeroData.subtitle}
            ctaLabel={travelInsuranceLaunchPadHeroData.ctaLabel}
            ctaRoute={travelInsuranceLaunchPadHeroData.ctaRoute}
            imageSrc={travelInsuranceLaunchPadHeroData.imageSrc}
            imageAlt={travelInsuranceLaunchPadHeroData.imageAlt}
            features={travelInsuranceLaunchPadHeroData.features}
            footnote={travelInsuranceLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={travelInsuranceLaunchPadHeroData.title}
            subtitle={travelInsuranceLaunchPadHeroData.subtitle}
            ctaLabel={travelInsuranceLaunchPadHeroData.ctaLabel}
            ctaRoute={travelInsuranceLaunchPadHeroData.ctaRoute}
            imageSrc={travelInsuranceLaunchPadHeroData.imageSrc}
            imageAlt={travelInsuranceLaunchPadHeroData.imageAlt}
            features={travelInsuranceLaunchPadHeroData.features}
            footnote={travelInsuranceLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/online-insurance-quote') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={comboInsuranceLaunchPadHeroData.title}
            subtitle={comboInsuranceLaunchPadHeroData.subtitle}
            ctaLabel={comboInsuranceLaunchPadHeroData.ctaLabel}
            ctaRoute={comboInsuranceLaunchPadHeroData.ctaRoute}
            imageSrc={comboInsuranceLaunchPadHeroData.imageSrc}
            imageAlt={comboInsuranceLaunchPadHeroData.imageAlt}
            features={comboInsuranceLaunchPadHeroData.features}
            footnote={comboInsuranceLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={comboInsuranceLaunchPadHeroData.title}
            subtitle={comboInsuranceLaunchPadHeroData.subtitle}
            ctaLabel={comboInsuranceLaunchPadHeroData.ctaLabel}
            ctaRoute={comboInsuranceLaunchPadHeroData.ctaRoute}
            imageSrc={comboInsuranceLaunchPadHeroData.imageSrc}
            imageAlt={comboInsuranceLaunchPadHeroData.imageAlt}
            features={comboInsuranceLaunchPadHeroData.features}
            footnote={comboInsuranceLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/personal-loans') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={personalLoansLaunchPadHeroData.title}
            subtitle={personalLoansLaunchPadHeroData.subtitle}
            ctaLabel={personalLoansLaunchPadHeroData.ctaLabel}
            ctaRoute={personalLoansLaunchPadHeroData.ctaRoute}
            imageSrc={personalLoansLaunchPadHeroData.imageSrc}
            imageAlt={personalLoansLaunchPadHeroData.imageAlt}
            features={personalLoansLaunchPadHeroData.features}
            footnote={personalLoansLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={personalLoansLaunchPadHeroData.title}
            subtitle={personalLoansLaunchPadHeroData.subtitle}
            ctaLabel={personalLoansLaunchPadHeroData.ctaLabel}
            ctaRoute={personalLoansLaunchPadHeroData.ctaRoute}
            imageSrc={personalLoansLaunchPadHeroData.imageSrc}
            imageAlt={personalLoansLaunchPadHeroData.imageAlt}
            features={personalLoansLaunchPadHeroData.features}
            footnote={personalLoansLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/debt-counselling') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={debtCounsellingLaunchPadHeroData.title}
            subtitle={debtCounsellingLaunchPadHeroData.subtitle}
            ctaLabel={debtCounsellingLaunchPadHeroData.ctaLabel}
            ctaRoute={debtCounsellingLaunchPadHeroData.ctaRoute}
            imageSrc={debtCounsellingLaunchPadHeroData.imageSrc}
            imageAlt={debtCounsellingLaunchPadHeroData.imageAlt}
            features={debtCounsellingLaunchPadHeroData.features}
            footnote={debtCounsellingLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={debtCounsellingLaunchPadHeroData.title}
            subtitle={debtCounsellingLaunchPadHeroData.subtitle}
            ctaLabel={debtCounsellingLaunchPadHeroData.ctaLabel}
            ctaRoute={debtCounsellingLaunchPadHeroData.ctaRoute}
            imageSrc={debtCounsellingLaunchPadHeroData.imageSrc}
            imageAlt={debtCounsellingLaunchPadHeroData.imageAlt}
            features={debtCounsellingLaunchPadHeroData.features}
            footnote={debtCounsellingLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (
    pathName ===
    '/business-insurance-quote/car-and-commercial-property-insurance'
  ) {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={commercialPropertyLaunchPadHeroData.title}
            subtitle={commercialPropertyLaunchPadHeroData.subtitle}
            ctaLabel={commercialPropertyLaunchPadHeroData.ctaLabel}
            ctaRoute={commercialPropertyLaunchPadHeroData.ctaRoute}
            imageSrc={commercialPropertyLaunchPadHeroData.imageSrc}
            imageAlt={commercialPropertyLaunchPadHeroData.imageAlt}
            features={commercialPropertyLaunchPadHeroData.features}
            footnote={commercialPropertyLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={commercialPropertyLaunchPadHeroData.title}
            subtitle={commercialPropertyLaunchPadHeroData.subtitle}
            ctaLabel={commercialPropertyLaunchPadHeroData.ctaLabel}
            ctaRoute={commercialPropertyLaunchPadHeroData.ctaRoute}
            imageSrc={commercialPropertyLaunchPadHeroData.imageSrc}
            imageAlt={commercialPropertyLaunchPadHeroData.imageAlt}
            features={commercialPropertyLaunchPadHeroData.features}
            footnote={commercialPropertyLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/debt-consolidation-loans') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={debtConsolidationLaunchPadHeroData.title}
            subtitle={debtConsolidationLaunchPadHeroData.subtitle}
            ctaLabel={debtConsolidationLaunchPadHeroData.ctaLabel}
            ctaRoute={debtConsolidationLaunchPadHeroData.ctaRoute}
            imageSrc={debtConsolidationLaunchPadHeroData.imageSrc}
            imageAlt={debtConsolidationLaunchPadHeroData.imageAlt}
            features={debtConsolidationLaunchPadHeroData.features}
            footnote={debtConsolidationLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={debtConsolidationLaunchPadHeroData.title}
            subtitle={debtConsolidationLaunchPadHeroData.subtitle}
            ctaLabel={debtConsolidationLaunchPadHeroData.ctaLabel}
            ctaRoute={debtConsolidationLaunchPadHeroData.ctaRoute}
            imageSrc={debtConsolidationLaunchPadHeroData.imageSrc}
            imageAlt={debtConsolidationLaunchPadHeroData.imageAlt}
            features={debtConsolidationLaunchPadHeroData.features}
            footnote={debtConsolidationLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/life-insurance-quote') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={lifeInsuranceLaunchPadHeroData.title}
            subtitle={lifeInsuranceLaunchPadHeroData.subtitle}
            ctaLabel={lifeInsuranceLaunchPadHeroData.ctaLabel}
            ctaRoute={lifeInsuranceLaunchPadHeroData.ctaRoute}
            imageSrc={lifeInsuranceLaunchPadHeroData.imageSrc}
            imageAlt={lifeInsuranceLaunchPadHeroData.imageAlt}
            features={lifeInsuranceLaunchPadHeroData.features}
            footnote={lifeInsuranceLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={lifeInsuranceLaunchPadHeroData.title}
            subtitle={lifeInsuranceLaunchPadHeroData.subtitle}
            ctaLabel={lifeInsuranceLaunchPadHeroData.ctaLabel}
            ctaRoute={lifeInsuranceLaunchPadHeroData.ctaRoute}
            imageSrc={lifeInsuranceLaunchPadHeroData.imageSrc}
            imageAlt={lifeInsuranceLaunchPadHeroData.imageAlt}
            features={lifeInsuranceLaunchPadHeroData.features}
            footnote={lifeInsuranceLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/funeral-insurance-quote') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={funeralInsuranceLaunchPadHeroData.title}
            subtitle={funeralInsuranceLaunchPadHeroData.subtitle}
            ctaLabel={funeralInsuranceLaunchPadHeroData.ctaLabel}
            ctaRoute={funeralInsuranceLaunchPadHeroData.ctaRoute}
            imageSrc={funeralInsuranceLaunchPadHeroData.imageSrc}
            imageAlt={funeralInsuranceLaunchPadHeroData.imageAlt}
            features={funeralInsuranceLaunchPadHeroData.features}
            footnote={funeralInsuranceLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={funeralInsuranceLaunchPadHeroData.title}
            subtitle={funeralInsuranceLaunchPadHeroData.subtitle}
            ctaLabel={funeralInsuranceLaunchPadHeroData.ctaLabel}
            ctaRoute={funeralInsuranceLaunchPadHeroData.ctaRoute}
            imageSrc={funeralInsuranceLaunchPadHeroData.imageSrc}
            imageAlt={funeralInsuranceLaunchPadHeroData.imageAlt}
            features={funeralInsuranceLaunchPadHeroData.features}
            footnote={funeralInsuranceLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  if (pathName === '/home-insurance-quote') {
    return (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CarInsuranceLaunchPadHeroDesktop
            key={heroGateKey}
            title={homeContentsLaunchPadHeroData.title}
            subtitle={homeContentsLaunchPadHeroData.subtitle}
            ctaLabel={homeContentsLaunchPadHeroData.ctaLabel}
            ctaRoute={homeContentsLaunchPadHeroData.ctaRoute}
            imageSrc={homeContentsLaunchPadHeroData.imageSrc}
            imageAlt={homeContentsLaunchPadHeroData.imageAlt}
            features={homeContentsLaunchPadHeroData.features}
            footnote={homeContentsLaunchPadHeroData.footnote}
            footnoteAlign="left"
            onImageLoad={onImageLoad}
          />
        ) : (
          <CarInsuranceLaunchPadHeroMobile
            key={heroGateKey}
            title={homeContentsLaunchPadHeroData.title}
            subtitle={homeContentsLaunchPadHeroData.subtitle}
            ctaLabel={homeContentsLaunchPadHeroData.ctaLabel}
            ctaRoute={homeContentsLaunchPadHeroData.ctaRoute}
            imageSrc={homeContentsLaunchPadHeroData.imageSrc}
            imageAlt={homeContentsLaunchPadHeroData.imageAlt}
            features={homeContentsLaunchPadHeroData.features}
            footnote={homeContentsLaunchPadHeroData.footnote}
            footnoteAlign="center"
            onImageLoad={onImageLoad}
          />
        )}
      </ScrollFadeWrapper>
    );
  }

  return isMobile.isDesktop ? (
    <LaunchPad
      key={heroGateKey}
      pathName={pathName}
      onImageLoad={onImageLoad}
    />
  ) : (
    <LaunchPadMobile
      key={heroGateKey}
      pathName={pathName}
      onImageLoad={onImageLoad}
    />
  );
};

export default SubPageHero;
